import { required, between, requiredIf, maxLength } from 'vuelidate/lib/validators';
import store from '@/store/index';

const valueMustBeGreaterThenZeroForCreateBooking = (value) => {
    const hasShipmentOptions = store.getters['createShipment/hasShipmentOptions'];
    const isCustomsRequired = store.getters['createShipment/requireCustoms'];
    if (hasShipmentOptions && value === 0 && isCustomsRequired) {
        return false;
    }
    return true;
};

export default {
        amount: {
            required,
            between: between(0, 999999999),
            valueMustBeGreaterThenZeroForCreateBooking
        },
        currencyCode: {
            required: requiredIf(function() {
                return this.shipment.customsAmount.amount !== 0;
            })
        },
          commodities: {
                    $each: {
                        description: {
                            required,
                        },
                        harmonizedCode: {
                            required
                        },
                        countryOfManufacture: {
                            required
                        },
                        unitWeight: {
                            required,
                            between: between(0.1, 999999999)
                        },
                        quantity: {
                            required,
                            between: between(1, 999999999)
                        },
                        unitPrice: {
                            amount: {
                                required,
                                between: between(0.1, 999999999)
                            },
                            currencyCode: {
                                required
                            }
                        }
                     }
                }
};
